import { ScanLine, Zap, Activity, Cpu, Code2, CircleAlert, ArrowLeftRight, Gauge, Fuel } from "lucide-react";
import { Reveal } from "./Reveal";
import { IMAGES } from "../constants/business";

const CAPABILITIES = [
  { icon: ScanLine, label: "Advanced scan-tool diagnostics" },
  { icon: Zap, label: "Electrical troubleshooting" },
  { icon: Activity, label: "Live vehicle data analysis" },
  { icon: Cpu, label: "Module diagnostics" },
  { icon: Code2, label: "Programming & relearn procedures" },
  { icon: CircleAlert, label: "ABS diagnostics" },
  { icon: ArrowLeftRight, label: "Transmission diagnostics" },
  { icon: Gauge, label: "Engine performance diagnostics" },
  { icon: Fuel, label: "Diesel fuel system diagnostics" },
];

export const DiagnosticsSection = () => (
  <section id="diagnostics" className="px-6 md:px-12 lg:px-24 py-24 md:py-32 bg-[#0A0A0A]" data-testid="diagnostics-section">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-start">
      <div className="order-2 lg:order-1">
        <Reveal>
          <p className="text-[#FF3B30] text-xs uppercase tracking-[0.35em] font-semibold mb-4">03 — Advanced Diagnostics</p>
          <h2 className="font-oswald font-bold uppercase tracking-tight text-4xl sm:text-5xl leading-[1.02]" data-testid="diagnostics-heading">
            We Diagnose First.<br /><span className="text-zinc-500">Then We Fix.</span>
          </h2>
          <p className="mt-6 text-zinc-400 text-base md:text-lg max-w-xl">
            Replacing parts without a proper diagnosis wastes your money. Our professional
            diagnostic equipment and process find the actual cause — so the repair works the first time.
          </p>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-px bg-zinc-800 border border-zinc-800">
          {CAPABILITIES.map(({ icon: Icon, label }, i) => (
            <Reveal key={label} delay={(i % 2) * 0.08}>
              <div className="flex items-center gap-3 bg-[#0A0A0A] p-4 h-full hover:bg-zinc-900 transition-colors duration-300" data-testid={`diag-cap-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                <Icon className="w-5 h-5 shrink-0 text-[#FF3B30]" strokeWidth={1.5} />
                <span className="text-sm text-zinc-300">{label}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <Reveal className="order-1 lg:order-2 lg:sticky lg:top-28">
        <figure className="relative border border-zinc-800">
          <img
            src={IMAGES.diagnostics}
            alt="Technician running diagnostic scan tool on a vehicle engine"
            className="w-full h-[320px] sm:h-[420px] lg:h-[560px] object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
          <figcaption className="absolute bottom-0 left-0 p-6">
            <span className="block font-oswald uppercase tracking-tight text-2xl">Diagnosis before parts.</span>
            <span className="text-sm text-zinc-400">Professional equipment. Proven process.</span>
          </figcaption>
        </figure>
      </Reveal>
    </div>
  </section>
);
